import { Grid, TextField, Typography } from '@mui/material';
import { Field } from 'formik';
import { useTheme } from '@mui/material';

interface FormValues {
  name: string;
  description: string;
  address: string;
  host: string;
  ip: string;
  port: number;
  tenantId: string;
}

interface NetworkSettingsSectionProps {
  isSubmitting: boolean;
  touched: { [K in keyof FormValues]?: boolean };
  errors: { [K in keyof FormValues]?: string };
}

export function NetworkSettingsSection({ isSubmitting, touched, errors }: NetworkSettingsSectionProps) {
  const theme = useTheme();

  return (
    <>
      <Grid item xs={12}>
        <Typography fontWeight={600} fontSize={16} color={theme.palette.text.primary} mb={2}>
          Configurações de Conexão
        </Typography>
      </Grid>

      <Grid item xs={12} sm={4}>
        <Field
          as={TextField}
          fullWidth
          label="Host"
          name="host"
          required
          disabled={isSubmitting}
          error={!!(touched.host && errors.host)}
          helperText={touched.host && errors.host}
          placeholder="Ex: api.example.com"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <Field
          as={TextField}
          fullWidth
          label="Endereço IP"
          name="ip"
          required
          disabled={isSubmitting}
          error={!!(touched.ip && errors.ip)}
          helperText={touched.ip && errors.ip}
          placeholder="Ex: 192.168.1.1"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <Field
          as={TextField}
          fullWidth
          label="Porta"
          name="port"
          type="number"
          required
          disabled={isSubmitting}
          error={!!(touched.port && errors.port)}
          helperText={touched.port && errors.port}
          placeholder="Ex: 8080"
          inputProps={{
            min: 1,
            max: 65535
          }}
        />
      </Grid>
    </>
  );
} 